import { useCallback, useMemo } from "react";
export function useChildKeyPressTreeContextValue(childKeyPressTreeNodeRef) {
    const registerChildActiveKeyPressTreeNode = useCallback((node) => {
        childKeyPressTreeNodeRef.current = node;
    }, [childKeyPressTreeNodeRef]);
    const unregisterChildActiveKeyPressTreeNode = useCallback((node) => {
        if (childKeyPressTreeNodeRef.current === node)
            childKeyPressTreeNodeRef.current = undefined;
    }, [childKeyPressTreeNodeRef]);
    return useMemo(() => {
        return {
            registerActiveKeyPressTreeNode: registerChildActiveKeyPressTreeNode,
            unregisterActiveKeyPressTreeNode: unregisterChildActiveKeyPressTreeNode,
        };
    }, [registerChildActiveKeyPressTreeNode, unregisterChildActiveKeyPressTreeNode]);
}
